import { Component } from '@angular/core';

import {
    CONNECTED_FOLDER_KEY, DOC_TYPES, INPUT_TYPES, L2_PROCESSES, LandscapeScope, SOURCE_KEYS, SOURCES, SUGGESTIONS
} from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

@Component({
    selector: 'df-ask-step',
    templateUrl: './df-ask-step.component.html',
    styleUrls: ['./df-ask-step.component.scss'],
    standalone: false
})
export class DfAskStepComponent {
    public readonly folderKey = CONNECTED_FOLDER_KEY;
    public readonly l2 = L2_PROCESSES;
    public readonly types = INPUT_TYPES;
    public readonly docTypes = DOC_TYPES as Record<string, (typeof DOC_TYPES)[keyof typeof DOC_TYPES]>;
    public readonly sourceKeys = SOURCE_KEYS;
    public readonly sources = SOURCES as Record<string, (typeof SOURCES)[keyof typeof SOURCES]>;
    public readonly suggestions = SUGGESTIONS;
    public readonly landscapes: [LandscapeScope, string][] = [['asis', 'As-Is (ECC)'], ['tobe', 'To-Be (S/4HANA)'], ['both', 'Both']];

    constructor(public df: DocumentFinderService) {}

    public get selectedProcesses() {
        return [...this.df.scope.l2].map(id => this.l2.find(process => process.id === id) ?? { id, name: '' });
    }

    public get availableProcesses() {
        return this.l2.filter(process => !this.df.scope.l2.has(process.id));
    }

    public useSuggestion(s: string): void {
        this.df.query = s;
    }

    public setLandscape(land: LandscapeScope): void {
        this.df.scope.land = land;
    }

    public run(): void {
        this.df.startSearch(this.df.query);
    }

    public connect(): Promise<void> {
        return this.df.connectFolder();
    }
}
